// extracted by mini-css-extract-plugin
export var btn = "G_mB s_r1 s_rD d_bz d_bP d_bD d_dw";
export var full = "G_wk d_w d_H";
export var hoverStyle = "G_mF";
export var zoom = "G_mG";